define.alias("shared/helpers/is-last", "calendar/helpers/is-last");